import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { RevenuesActions } from 'Store/Revenues/Revenues.actions';

const useHistoryPush = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const showExitBillingData = useSelector((state: IGlobalReducerState) => state.revenues.cancelPageUpdateBillingData);
  const showExitDowgrade = useSelector((state: IGlobalReducerState) => state.revenues.cancelPageDowngrade);
  const urlRedirect = useSelector((state: IGlobalReducerState) => state.revenues.urlRedirect);

  useEffect(() => {
    if (!showExitBillingData) {
      historyRedirect();
    }
  }, [showExitBillingData]);

  useEffect(() => {
    if (!showExitDowgrade) {
      historyRedirect();
    }
  }, [showExitDowgrade]);

  const historyPush = (path: string) => {
    if (showExitBillingData) {
      dispatch(RevenuesActions.showModalExitBillingData(true));
      return dispatch(RevenuesActions.urlRedirect(path));
    }
    if (showExitDowgrade) {
      dispatch(RevenuesActions.showModalExitDowgrade(true));
      return dispatch(RevenuesActions.urlRedirect(path));
    }

    return navigate(path);
  }

  const historyRedirect = () => {
    if (urlRedirect && (!showExitBillingData && !showExitDowgrade)) {
      navigate(urlRedirect);
      return dispatch(RevenuesActions.urlRedirect(''));
    }
  }

  return { historyPush, historyRedirect, urlRedirect };
};

export default useHistoryPush;
